/**
 * Public half of the Turnstile widget guarding the demo form. The secret
 * half lives only in the Pages Function (functions/api/demo-request.ts).
 * Unset → no widget renders, and the function rejects the submission.
 */
export const TURNSTILE_SITE_KEY = import.meta.env.VITE_TURNSTILE_SITE_KEY || ''
